<template>
    <div class="customer-list-input">
        <v-select
            :placeholder="placeholder"
            :clearable="true"
            :filterable="true"
            :filter="fuseOrdersSearchFilter"
            :options="customers"
            :reduce="(option) => option.id"
            :get-option-label="(option) => option.name"
            multiple
            v-model="selectedCustomers"
        >
            <template #no-options>
                Aucun client ne correspond à votre recherche
            </template>
            <template #option="customer">
                {{ customer.name }} #{{ customer.id }}
            </template>
        </v-select>
        <input v-for="selectedCustomer in selectedCustomers" :key="selectedCustomer" type="hidden" :name="name + '[]'" :value="selectedCustomer">
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import Fuse from "fuse.js"

    export default {
        name: "CustomerListInput",

        components: {
            vSelect,
        },

        data: function () {
            let preSelectedCustomers = [];
            if (this.value) {
                for (const c of this.value) {
                    if (typeof c === 'string') {
                        preSelectedCustomers.push(parseInt(c));
                    } else {
                        preSelectedCustomers.push(c);
                    }
                }
            }

            return {
                selectedCustomers: preSelectedCustomers,
            };
        },

        props: {
            name: {
                type: String,
                required: true,
            },
            value: {
                type: Array,
                required: false,
            },
            customers: {
                type: Array,
                required: true,
            },
            placeholder: {
                type: String,
                required: false,
            },
        },

        methods: {
            fuseOrdersSearchFilter (options, search) {
                const fuse = new Fuse(options, {
                    keys: ['name'],
                    shouldSort: true,
                    includeScore: true,
                });
                let fuseList = search.length ? fuse.search(search) : fuse.list;
                let filtered = [];
                for (const key in fuseList) {
                    filtered.push(fuseList[key].item);
                }
                return filtered;
            },
        },
    }
</script>
